import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { T } from '@sm/intl';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
const COPY = {
  AddAccepted: {
    id: 'buildWithAI.QuestionModification.AddAccepted',
    defaultMessage: '(Added)',
    description: '[Type: Label][Vis: med] - indicate to user a question was added'
  },
  AddProposed: {
    id: 'buildWithAI.QuestionModification.AddProposed',
    defaultMessage: 'Added',
    description: '[Type: Label][Vis: med] - indicate to user a question was added'
  },
  DeleteAccepted: {
    id: 'buildWithAI.QuestionModification.DeleteAccepted',
    defaultMessage: '(Deleted)',
    description: '[Type: Label][Vis: med] - indicate to user a question was deleted'
  },
  DeleteProposed: {
    id: 'buildWithAI.QuestionModification.DeleteProposed',
    defaultMessage: 'Deleted',
    description: '[Type: Label][Vis: med] - indicate to user a question was deleted'
  },
  UpdateAccepted: {
    id: 'buildWithAI.QuestionModification.UpdateAccepted',
    defaultMessage: '(Updated)',
    description: '[Type: Label][Vis: med] - indicate to user a question was updated'
  },
  UpdateProposed: {
    id: 'buildWithAI.QuestionModification.UpdateProposed',
    defaultMessage: 'Updated',
    description: '[Type: Label][Vis: med] - indicate to user a question was updated'
  }
};
const useStyles = createUseStyles(theme => ({
  modificationBoxProposed: {
    borderColor: theme.palette.primary.main,
    borderStyle: 'solid',
    borderRadius: '8px',
    borderWidth: '1px'
  },
  '@keyframes fade': {
    from: {
      background: theme.palette.background.primary.light,
      borderStyle: 'solid',
      borderRadius: '8px',
      borderWidth: '1px',
      borderColor: theme.palette.primary.main
    },
    to: {}
  },
  modificationBoxAccepted: {
    animation: '$fade 3s forwards'
  }
}));
const QuestionModification = ({
  modifiedQuestion,
  variant = 'proposed',
  children
}) => {
  const {
    modificationBoxProposed,
    modificationBoxAccepted
  } = useStyles({
    variant
  });
  const action = modifiedQuestion.action;
  const determineCopyAccepted = () => {
    if (action === 'add') {
      return COPY.AddAccepted;
    } else if (action === 'delete') {
      return COPY.DeleteAccepted;
    }
    return COPY.UpdateAccepted;
  };
  const determineCopyProposed = () => {
    if (action === 'add') {
      return COPY.AddProposed;
    } else if (action === 'delete') {
      return COPY.DeleteProposed;
    }
    return COPY.UpdateProposed;
  };
  return _jsxs(_Fragment, {
    children: [action !== 'same' && variant === 'proposed' && _jsxs(Box, {
      className: modificationBoxProposed,
      p: 4,
      children: [_jsx(Box, {
        mb: 2,
        children: _jsx(Typography, {
          color: "primary",
          variant: "bodySm",
          children: _jsx("i", {
            children: _jsx(T, {
              desc: determineCopyProposed()
            })
          })
        })
      }), action !== 'delete' && children]
    }), (action === 'add' || action === 'update') && variant === 'accepted' && _jsxs(Box, {
      className: modificationBoxAccepted,
      p: 4,
      children: [_jsx(Box, {
        mb: 2,
        children: _jsx(Typography, {
          color: "primary",
          variant: "bodySm",
          children: _jsx(T, {
            desc: determineCopyAccepted()
          })
        })
      }), children]
    }), action === 'same' && children]
  });
};
export default QuestionModification;